<div class="date-options-container">
  @for (option of dateRangeOptions(); track option.key) {
    @if (!selectedOption() || selectedOption() === option.key) {
      @if (option.key === dateRangeFilters.Custom) {
        <button
          class="date-option-chip"
          [class.selected-date-option-chip]="selectedOption()"
          [class.picker-is-open]="rangePicker.opened"
          (click)="rangePicker.open()"
        >
          <app-icon class="calendar-icon" [icon]="IconName.CALENDAR" />

          @if (!selectedOption()) {
            {{ option.label | translate }}
          } @else {
            {{ rangeForm.controls['startDate'].value | date: dateRangeFormat }} -
            {{ rangeForm.controls['endDate'].value | date: dateRangeFormat }}

            <button class="close-btn" (click)="cancelDatePicker($event)">
              <app-icon class="close-icon" [icon]="IconName.CLOSE" />
            </button>
          }
        </button>

        <mat-form-field class="hidden-datepicker">
          <mat-date-range-input [formGroup]="rangeForm" [rangePicker]="rangePicker">
            <input matStartDate formControlName="startDate" placeholder="Start date" />
            <input matEndDate formControlName="endDate" placeholder="End date" />
          </mat-date-range-input>

          <mat-date-range-picker #rangePicker (closed)="onPickerClosed()" />
        </mat-form-field>
      } @else {
        <button
          class="date-option-chip"
          [class.selected-date-option-chip]="selectedOption()"
          (click)="toggleOption(option.key, !selectedOption())"
        >
          {{ option.label | translate }}

          @if (selectedOption()) {
            <button class="close-btn">
              <app-icon class="close-icon" [icon]="IconName.CLOSE" />
            </button>
          }
        </button>
      }
    }
  }
</div>
